import { GridColDef } from '@mui/x-data-grid';
import Icons from '../../../components/icons';
import { Bus, GetBusColumnsArgs } from '../types/busTypes';
import { Box, IconButton, Tooltip } from '@mui/material';
import { QrLink, UnlinkButton } from '../styled';

const getBusColumns = ({
  onUnlink,
  onEdit,
  onDelete,
  onGenerateQr
}: GetBusColumnsArgs): GridColDef[] => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 160
  },
  {
    field: 'licensePlateNo',
    headerName: 'License Plate Number',
    flex: 1,
    minWidth: 160
  },
  {
    field: 'deviceId',
    headerName: 'Linked Device',
    minWidth: 150,
    flex: 1,
    renderCell: (params) => {
      const row = params.row as Bus;
      return row.deviceId ? row.deviceId : '—';
    }
  },
  {
    field: 'qrGenerator',
    headerName: 'QR Code',
    flex: 1,
    minWidth: 160,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      const row = params.row as Bus;
      return <QrLink onClick={() => onGenerateQr(row)}>Generate QR</QrLink>;
    }
  },
  {
    field: 'edit',
    headerName: 'Actions',
    sortable: false,
    filterable: false,
    minWidth: 100,
    headerAlign: 'center',
    renderCell: (params) => {
      const row = params.row as Bus;
      return (
        <Box>
          <Tooltip title='Edit'>
            <IconButton
              size='small'
              onClick={() => onEdit(row)}
              aria-label='edit bus'
            >
              <Icons.EditBlackOutlined />
            </IconButton>
          </Tooltip>
          <Tooltip title='Delete'>
            <IconButton
              size='small'
              onClick={() => onDelete(row)}
              aria-label='delete bus'
              color='error'
            >
              <Icons.Delete />
            </IconButton>
          </Tooltip>
        </Box>
      );
    }
  },
  {
    field: 'unlinkDevice',
    headerName: 'Unlink Device',
    sortable: false,
    filterable: false,
    minWidth: 140,
    renderCell: (params) => {
      const row = params.row as Bus;
      return (
        <UnlinkButton
          size='small'
          onClick={() => row.deviceId && onUnlink(row)}
          variant='contained'
          startIcon={<Icons.Unlink />}
          disabled={!row.deviceId}
        >
          Unlink
        </UnlinkButton>
      );
    }
  }
];
export default getBusColumns;
